export default __webpack_public_path__ + "static/media/ui-icon-ticket-currency.0e8cd7dd.png";